import { axiosInstance } from ".";

const getServicesList = async (params) =>
  await axiosInstance.get("/services", { params });

const addService = async (payload) =>
  await axiosInstance.post("/services", payload);

const getServiceDetails = async ({ id }) =>
  await axiosInstance.get(`/services/${id}`);

const editService = async ({ id, data }) =>
  await axiosInstance.put(`/services/${id}`, data);

const deleteService = async ({ id }) =>
  await axiosInstance.delete(`/services/${id}`);

const editServiceBulk = async (payload) =>
  await axiosInstance.patch(`/services/bulk_update`, payload);

export {
  getServicesList,
  addService,
  getServiceDetails,
  editService,
  deleteService,
  editServiceBulk,
};
